import { gql } from "apollo-angular";

export const GET_CODE = gql`
    query GetOrderForCheckout {
        activeOrder {
            code
        }
    }
`;
